import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const MultiTextSearchMatcher: FieldMatcher = {
  name: 'multiTextSearch',
  displayName: 'Contains',
  hasEditor: true,
  options: {
    chipFormatter: (value: string): string => {
      try {
        const parsed = JSON.parse(value);
        const values: string[] = parsed.values ?? parsed;
        if (values.length === 0) return '';
        if (values.length === 1) return `: ${values[0]}`;
        return `: ${values[0]} +${values.length - 1} more`;
      } catch {
        return `: ${value}`;
      }
    },
  },
};
